import type { Vector2 } from "./types";

export function clamp(value: number, min: number, max: number): number {
  return Math.min(max, Math.max(min, value));
}

export function lerp(from: number, to: number, amount: number): number {
  return from + (to - from) * amount;
}

export function lerpVector(from: Vector2, to: Vector2, amount: number): Vector2 {
  return {
    x: lerp(from.x, to.x, amount),
    y: lerp(from.y, to.y, amount),
  };
}

export function length(x: number, y: number): number {
  return Math.hypot(x, y);
}

export function moveTowards(current: number, target: number, maxDelta: number): number {
  if (Math.abs(target - current) <= maxDelta) {
    return target;
  }
  return current + Math.sign(target - current) * maxDelta;
}

export function normalizedSpeed(vx: number, vy: number): number {
  return Math.hypot(vx, vy);
}
